import { useState } from "react";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { ConfirmDialog } from "shared/components/modals/ConfirmDialog";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import addressApi, {
  MUTATION_REVALIDATE_PARTNER_ADDRESSES
} from "api/landlord/address";

export const ValidateAllAddressesButton = () => {
  const [isConfirming, setIsConfirming] = useState(false);
  const queryClient = useQueryClient();

  const { mutate: validateAll, isPending } = useMutation({
    mutationKey: [MUTATION_REVALIDATE_PARTNER_ADDRESSES],
    mutationFn: () => addressApi.revalidatePartnerAddresses(),
    onSuccess: () => {
      toast.success(
        "Re-checking every address. Statuses update as each one finishes."
      );
      queryClient.invalidateQueries({ queryKey: ["properties"] });
      setIsConfirming(false);
    },
    onError: () => {
      toast.error("Couldn't start the address check. Please try again.");
      setIsConfirming(false);
    }
  });

  return (
    <>
      <Button
        variant={ButtonVariant.BASE}
        size={ButtonSize.SM}
        className="shrink-0 whitespace-nowrap"
        loading={isPending}
        disabled={isPending}
        onClick={() => setIsConfirming(true)}
      >
        Check addresses
      </Button>
      <ConfirmDialog
        opened={isConfirming}
        onClose={() => setIsConfirming(false)}
        onConfirm={() => validateAll()}
        variant="primary"
        title="Re-check every address?"
        description="Every property and unit address in your portfolio is checked again, including ones already marked Verified. This runs in the background and can take a while on a large portfolio."
        confirmButton={{ label: "Re-check all", loading: isPending }}
        cancelButton={{ label: "Cancel" }}
      />
    </>
  );
};
